module.exports = __webpack_public_path__ + "static/media/go_to_gallery_green.e5a2d3a7.svg";